import React,{useEffect, useState} from 'react';
import './ChatDetails.css';
import Avatar from '../../../assets/dp.jpg';
import {Tag} from 'antd';
import userService from '../../../services/user.service';
import orderService from '../../../services/order.service';

const ChatDetails = ({currentChatUser,currentUser,setCurrentChatUserPic})=>{
    const [userDetails,setUserDetails] = useState(null);
    const [currentOrders,setCurrentOrders] = useState([]);
    useEffect(async ()=>{
        if(currentChatUser){
            try{
                const res = await userService.getUserById(currentChatUser);
                // console.log(res.data);
                setUserDetails(res.data);
                setCurrentChatUserPic(res.data.profilePicture);
            }catch(err){
                console.log(err);
            }
            
        }
       
    },[currentChatUser])
    // console.log("CUrrent chat user : ",currentChatUser);


    useEffect(async ()=>{
        
        if(currentChatUser){
            if(currentUser.roles[0].toLowerCase()==='role_user'){
                try{
                    const res = await orderService.getCreatedOrder(currentUser.id);
                    // console.log("FETCHED ORDER:",res.data);
                    const currentProject = []
                    res.data.map((o)=>{
                        if(o.assignedEmployee.length>0){
                            o.assignedEmployee.map(e=>{
                                if(e._id===currentChatUser){
                                    currentProject.push(o);
                                }
                            })
                        }
                    })
                    // console.log("FINAL CHAT ORDER DATA :",currentProject);
                    setCurrentOrders(currentProject);
                    
                }catch(err){
                    console.log(err);
                }
            }
               
        }
       
    },[currentUser,currentChatUser])

  
    return(
        <div>
            <div className="chat-details-header">
            <h3>Chat Details</h3>
            </div>
            <div className="details-section">
                <div className="profile-pic">
                    <img src={userDetails ? (userDetails.profilePicture ? userDetails.profilePicture:Avatar) : (currentUser.profilePicture ? currentUser.profilePicture : Avatar)} alt="profile-pic" />
                </div>
                <div className="info-section">
                    <h5>{userDetails?userDetails.username : currentUser.username}</h5>
                    <p>( {userDetails?userDetails.id : currentUser.id} ) </p>
                    {userDetails?
                    <>
                    <div className="project-heading"><h6>Project Details</h6></div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>
                                    Title
                                </th>
                                <th>
                                    Deadline
                                </th>
                                <th>
                                    Status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                           {currentOrders &&
                            currentOrders.map(o=>{
                                return(
                                <tr>
                                    <td>{o.name}</td>
                                    <td>{o.deadline}</td>
                                    <td><Tag color="cyan">{o.status ? o.status : "Requested"}</Tag></td>
                                </tr>)
                            })
                           }
                        </tbody>
                    </table>
                    </>:
                    <div>
                    <div className="project-heading"><h6>Your Details</h6></div>
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <td>{currentUser.name}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Email</th>
                                <td>{currentUser.email}</td>
                            </tr>
                            <tr>
                                <th>Address</th>
                                <td>{currentUser.address ? currentUser.address : "NOT SET"}</td>
                            </tr>
                            <tr>
                                <th>Contact</th>
                                <td>{currentUser.contact ?currentUser.contact:"NOT SET"}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    }
                </div>
            </div>
            
        </div>
    )
}

export default ChatDetails;